<template>
<div id="wechatlogin">
  登录中...
</div>
</template>

<script>
/**
 * 微信跳转登录专用，避免重定向问题
 * 登录页面从 sagi-api 跳转过来之后，先来到这个页面，写入 session storage
 */
import cache from '@/core/cache'
import auth from '@/core/auth'

export default {
  name: 'wechatlogin',
  created () {
    // 检测是否有微信登录流程
    const wxloginObj = auth.checkWechatAuth()
    if (wxloginObj) {
      console.log('wxloginObj in query string: %o', wxloginObj)
      if (wxloginObj.error) {
        // 登录失败需要登出，取消所有缓存
        auth.logout()
        alert(decodeURIComponent(wxloginObj.error))
      } else {
        cache.setValue('wechatLogin', wxloginObj)
        // 清空 search 字符串避免再次调用
        // 跳转到首页。首页会检测 wechatLogin 这个缓存的数据来登录。
        // 为使用 window.location.search = '' 会引发跳转。还不如直接使用 href 强行跳转
        window.location.href = window.location.pathname
      }
    }
  }
}
</script>
